import { React, useEffect } from 'react';
import 'cloudinary-video-player/cld-video-player.min.css';
import { useState } from "react";
import Loader from "react-js-loader";
import { BsBuildingGear } from "react-icons/bs";
import Slider from "react-slick";
import { getFirestore, collection, query, getDocs, orderBy } from 'firebase/firestore';
import timeAgo from "../../src/scripts/functions";
import ListItem from "../../src/widgets/ListItem";
import ItemView from "../../src/widgets/ItemView";

let cachedHabariData = null;

export default function Habari() {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const firestore = getFirestore();
    const [activeItem, setActiveItem] = useState({});

    async function fetchData() {
        if (cachedHabariData) {
            setData(cachedHabariData);
            setIsLoading(false);
            return;
        }
        try {
            const querySnapshot = await getDocs(query(collection(firestore, "habari"), orderBy("dateCreated", 'desc')));
            const list = [];
            querySnapshot.docs.forEach((doc) => {
                list.push(doc.data());
            });
            cachedHabariData = list;
            setData(list);
            setIsLoading(false);
        }
        catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        // When activeItem changes and is not empty, push a new history state
        if (Object.keys(activeItem).length > 0) {
            window.history.pushState({ view: 'item' }, '');
        }
    }, [activeItem]);


    useEffect(() => {
        const handleBack = (event) => {
            if (Object.keys(activeItem).length > 0) {
                event.preventDefault();

                // Call your custom function
                setActiveItem({});
                // Replace current state with list view
                window.history.replaceState({ view: 'list' }, '');
            }
        };

        window.addEventListener('popstate', handleBack);
        return () => {
            window.removeEventListener('popstate', handleBack);
        };
    }, [activeItem]);

    const closeView = () => {
        setActiveItem({});
        // When manually closing, go back in history
        window.history.back();
    }

    return (
        <div className={''}>
            <div className="mainContainer">

                <div className={'mainContent max-w-5xl float'}>
                    <br></br>

                    <div className={'projectBox'}>
                        {isLoading ? (
                            <div className='loader'>
                                <Loader type='spinner-default' bgColor='#FC7F03' size='50' />
                            </div>
                        ) : data.length === 0 ? (
                            <div className={'jaza'}>
                                <BsBuildingGear size={80} color={'#d6d7d6'} />
                                <br></br>
                                <br></br>
                                <span className={'fadedText'}>Hakuna habari bado</span>
                            </div>
                        ) : Object.keys(activeItem).length === 0 ? (
                            data.map((item, index) => (
                                <div key={index} onClick={() => setActiveItem(item)}
                                    data-aos="fade-up"
                                    data-aos-delay={Math.min(index * 60, 300)}
                                >
                                    <ListItem item={item} />
                                    {index !== data.length - 1 && <div className={'horizontalDivider'}></div>}
                                </div>
                            ))
                        ) : (
                            <ItemView item={activeItem} action={closeView} />
                        )}
                    </div>
                </div>

                <br></br>
                <br></br>
            </div>
        </div>
    );
}